import { Container, Form, Row, Col } from 'react-bootstrap';
import { Address } from '../FormFields/Address';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { operationsAndInfoSchema } from '../../schemas/operationsAndInfoSchema';

import { ControlButtons } from '../ControlButtons';
import { useState } from 'react';
import { React } from 'react';

export const OperationsAndInfo = ({
	operInfo = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) => {
	const [weirdHours, setWeirdHours] = useState(false);

	const { register, handleSubmit, formState } = useForm({
		resolver: yupResolver(operationsAndInfoSchema),
		defaultValues: operInfo,
	});

	function unusualHours() {
		setWeirdHours(!weirdHours);
	}

	return (
		<Container className="component mt-5">
			<h2 className="mb-4">Facility and Operations Information</h2>
			<Form.Group>
				<Form.Label>Facility Name</Form.Label>
				<Form.Control type="text" autoFocus {...register('facilityName')} />
				<Form.Text className="text-danger">
					{formState.errors.facilityName?.message}
				</Form.Text>
			</Form.Group>
			<Row>
				<Form.Group as={Col} md="8" xs="12">
					<Form.Label>Site Address</Form.Label>
					<Form.Control type="text" {...register('siteAddress')} />
					<Form.Text className="text-danger">
						{formState.errors.siteAddress?.message}
					</Form.Text>
				</Form.Group>
				<Form.Group as={Col} md="4" xs="12">
					<Form.Label>City/Area</Form.Label>
					<Form.Control type="text" {...register('siteArea')} />
					<Form.Text className="text-danger">
						{formState.errors.siteArea?.message}
					</Form.Text>
				</Form.Group>
			</Row>
			<Address register={register} error={formState.errors} />
			<Row>
				<Form.Group as={Col} md="6" xs="12">
					<Form.Label>Person Responsible for Facility</Form.Label>
					<Form.Control type="text" {...register('facilityPerson')} />
					<Form.Text className="text-danger">
						{formState.errors.facilityPerson?.message}
					</Form.Text>
				</Form.Group>
				<Form.Group as={Col} md="6" xs="12">
					<Form.Label>Principle Business Activity</Form.Label>
					<Form.Control type="text" {...register('businessActivity')} />
					<Form.Text className="text-danger">
						{formState.errors.businessActivity?.message}
					</Form.Text>
				</Form.Group>
			</Row>
			<Row>
				<Form.Group as={Col} md="4" xs="12">
					<Form.Label>Title</Form.Label>
					<Form.Control type="text" {...register('title')} />
					<Form.Text className="text-danger">
						{formState.errors.title?.message}
					</Form.Text>
				</Form.Group>
				<Form.Group as={Col} md="4" xs="12">
					<Form.Label>Number of Employees</Form.Label>
					<Form.Control type="number" {...register('numEmployees')} />
					<Form.Text className="text-danger">
						{formState.errors.numEmployees?.message}
					</Form.Text>
				</Form.Group>
				<Form.Group as={Col} md="4" xs="12">
					<Form.Label>Number of Shifts</Form.Label>
					<Form.Control type="number" {...register('numShifts')} />
					<Form.Text className="text-danger">
						{formState.errors.numShifts?.message}
					</Form.Text>
				</Form.Group>
			</Row>
			<Form.Label>Hours of Operation (assumed M-F)</Form.Label>
			<Row>
				<Form.Group as={Col}>
					<Form.Control type="time" {...register('hrsOperation.open')} />
					<Form.Text className="text-danger">
						{formState.errors.hrsOperation?.open?.message}
					</Form.Text>
				</Form.Group>
				to
				<Form.Group as={Col}>
					<Form.Control type="time" {...register('hrsOperation.close')} />
					<Form.Text className="text-danger">
						{formState.errors.hrsOperation?.close?.message}
					</Form.Text>
				</Form.Group>
			</Row>
			<Form.Check
				className="mb-3"
				type="checkbox"
				label="Unusual Work Hours?"
				onChange={unusualHours}
			/>
			{weirdHours && (
				<Form.Group>
					<p>
						If your company as unusual hours (e.g. different hours on different
						days, extended work week, etc), please fill out your company's hours
						of operation below.
					</p>
					<Form.Control
						as="textarea"
						{...register('hrsOperation.additionalHours')}
						style={{ height: '100px' }}
					/>
				</Form.Group>
			)}
			<ControlButtons
				onNext={handleSubmit(onNext)}
				onPrev={onPrevious}
				onSubmit={handleSubmit(onSubmit)}
				finalStep={finalStep}
				disablePrev={disablePrev}
				disableNext={disableNext}
			/>
		</Container>
	);
};
